import { useSetting } from '../../../util/useSetting';
import { useState } from 'react';
const CLASSLIST =[
    'Class A',
    'Class B',
    'Class C',
    'Class D',
    'Class E',
    'Class F',
]
export default function ClassSelectionPopup({ showClassSelectionPopup, setShowClassSelectionPopup }) {
    const { fontSize } = useSetting();
    const [selectedClasses, setSelectedClasses] = useState([]);
    if (!showClassSelectionPopup) return null;
    return (
        <div className='fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-[99] rounded-[16px]' style={{fontSize}}>
            <div className='w-[1000px] max-w-[80%] bg-white flex flex-col items-center' style={{
                backgroundImage: `url(/secondary/bg_class.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                borderRadius: '16px',
            }}>
                <div className='bg-[#D9F4F4] w-full flex items-center text-center justify-center font-bold py-[16px]' style={{ fontSize: fontSize+4, borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                    上課互動區
                </div>
                <div className='w-full text-center py-[8px] font-bold noto-san-hk my-[16px]' style={{fontSize: fontSize+4}}>顯示設定</div>
                <div className='w-[70%] flex flex-wrap flex-row justify-start gap-[32px] py-[8px] mt-[16px] mb-[64px]'>
                    {CLASSLIST.map((className) => (
                        <div key={className} className='px-[8px] py-[4px] min-w-[140px] rounded-[8px] checkbox-main gap-[6px] flex flex-row items-center noto-san-hk'>
                            <input
                                type="checkbox"
                                checked={selectedClasses.includes(className)}
                                onChange={() => {
                                    if (selectedClasses.includes(className)) {
                                        setSelectedClasses(selectedClasses.filter(c => c !== className));
                                    } else {
                                        setSelectedClasses([...selectedClasses, className]);
                                    }
                                }}
                            />
                            <span>{className}</span>
                        </div>
                    ))}
                </div>

                <div className='flex w-full flex-row items-center justify-center py-[16px] gap-[16px] noto-san-hk mb-[24px]'>
                    <button
                        className='px-[16px] py-[8px] text-black rounded-[8px] font-bold w-[190px] rounded-full' style={{background: 'linear-gradient(to bottom, #BEBEBE90, #fff)'}}
                        onClick={() => setShowClassSelectionPopup(false)}
                    >
                        取消
                    </button>
                    <button
                        className='px-[16px] py-[8px] text-white text-white rounded-[8px] font-bold w-[190px] rounded-full' style={{background: 'linear-gradient(to right, #178E95, #07162F)'}}
                        onClick={() => setShowClassSelectionPopup(false)}
                    >
                        顯示互動區
                    </button>
                </div>
            </div>
        </div>
    );
}